<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            v-if="$route.name != `ProfilePage`"
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>
            {{
              $route.name == "ProfilePage" ? `My Profile` : `Edit User`
            }}</span
          >
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="$route.name != 'ProfilePage'">
              <v-text-field
                v-model="form.gstin"
                outlined
                label="Customer GSTIN"
                hint="Printed on the customer's tax invoices when GST applies"
                maxlength="15"
                prepend-inner-icon="mdi-file-certificate-outline"
                :error-messages="errors.gstin"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="$route.name != 'ProfilePage'">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                @input="UpdateUpline"
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <v-btn v-can:edit="$route.path.startsWith('/profile') ? null : 'users'"
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            @click="save"
          >
            Update {{ $route.name == "ProfilePage" ? `Profile` : `User` }}
          </v-btn>

          <template v-if="$route.name == 'ProfilePage'">
            <v-divider class="mt-5 mb-5"> </v-divider>
            <h3 class="mb-4">Change Password</h3>
            <v-row>
              <v-col sm="4">
                <v-text-field
                  v-model="passwordForm.current_password"
                  outlined
                  label="Current Password"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  :append-icon="showCurrentPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  prepend-inner-icon="mdi-lock-outline"
                  :error-messages="passwordErrors.current_password"
                  @click:append="showCurrentPassword = !showCurrentPassword"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model="passwordForm.password"
                  outlined
                  label="New Password"
                  :type="showNewPassword ? 'text' : 'password'"
                  :append-icon="showNewPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  prepend-inner-icon="mdi-lock-outline"
                  :error-messages="passwordErrors.password"
                  @click:append="showNewPassword = !showNewPassword"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model="passwordForm.password_confirmation"
                  outlined
                  label="Confirm New Password"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  :append-icon="showConfirmPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  prepend-inner-icon="mdi-lock-check-outline"
                  :error-messages="passwordErrors.password_confirmation"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-btn
              :loading="isChangingPassword"
              :disabled="isChangingPassword"
              color="primary"
              rounded
              @click="changePassword"
            >
              Change Password
            </v-btn>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UserEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
      isFetching: false,
      passwordForm: {
        current_password: "",
        password: "",
        password_confirmation: "",
      },
      passwordErrors: {},
      isChangingPassword: false,
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      positionItems: [],
      supervisorDownlined: [
        "Field Executive",
        "Merchandiser",
        "Promoter",
        "Van Sales",
      ],
      typeItems: [
        { id: "PENDING", text: "PENDING", value: 1 },
        { id: "APPROVED", text: "APPROVED", value: 0 },
      ],
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getMasters();
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=user`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.userId;
      axios
        .get(`/users/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log(this.form);
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios
          .post(`/users`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
          })
          .catch((error) => {
            console.error(error);
            this.isUnAuthorised();
          });
        this.isLoading = false;
        if (this.$route.name == "ProfilePage") {
          // this.$router.push("/supervisor");
          window.location.href = "/auth/login";
        } else if (this.CurrentPageName == "UserCreatePage") {
          this.$router.push("/users");
        } else {
          this.$router.go(-1);
        }
      } catch (e) {
        this.isLoading = false;
      }
    },
    async changePassword() {
      this.passwordErrors = {};
      try {
        this.isChangingPassword = true;
        await axios.post("/change_password", this.passwordForm);
        this.passwordForm = {
          current_password: "",
          password: "",
          password_confirmation: "",
        };
        this.$store.dispatch("showSnackbar", {
          text: "Password changed successfully!",
          color: "success",
        });
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.passwordErrors = error.response.data.errors || {};
        }
        this.$store.dispatch("showSnackbar", {
          text:
            (error.response && error.response.data["sub-title"]) ||
            "Failed to change password.",
          color: "error",
        });
      } finally {
        this.isChangingPassword = false;
      }
    },
  },
};
</script>
